import React from 'react'

const QuoteIcon = () => (
  <svg
    width="25"
    height="19"
    viewBox="0 0 25 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.712 0.157581C10.5653 0.370914 11.12 1.05358 11.376 2.20558C10.1387 2.88825 8.88 3.91225 7.6 5.27758C6.32 6.64291 5.424 8.13625 4.912 9.75758H5.104C6.72533 9.75758 7.984 10.1842 8.88 11.0376C9.81867 11.8482 10.288 12.9149 10.288 14.2376C10.288 15.4749 9.81867 16.5202 8.88 17.3736C7.984 18.2269 6.896 18.6536 5.616 18.6536C4.08 18.6536 2.864 18.1202 1.968 17.0536C1.072 15.9442 0.624 14.6216 0.624 13.0856C0.624 10.4829 1.456 8.15758 3.12 6.10958C4.784 4.06158 6.98133 2.07758 9.712 0.157581ZM22.512 0.157581C23.3653 0.370914 23.92 1.05358 24.176 2.20558C22.9387 2.88825 21.68 3.91225 20.4 5.27758C19.12 6.64291 18.224 8.13625 17.712 9.75758H17.904C19.5253 9.75758 20.784 10.1842 21.68 11.0376C22.6187 11.8482 23.088 12.9149 23.088 14.2376C23.088 15.4749 22.6187 16.5202 21.68 17.3736C20.784 18.2269 19.696 18.6536 18.416 18.6536C16.88 18.6536 15.664 18.1202 14.768 17.0536C13.872 15.9442 13.424 14.6216 13.424 13.0856C13.424 10.4829 14.256 8.15758 15.92 6.10958C17.584 4.06158 19.7813 2.07758 22.512 0.157581Z"
      fill="#3E3E47"
    />
  </svg>
)

export default QuoteIcon
